export default __webpack_public_path__ + "static/media/0x823cd4264c1b951c9209ad0deaea9988fe8429bf.8c99c890.svg";